import { render } from "./StatisticsBar.vue?vue&type=template&id=61dd0618&scoped=true"
import script from "./StatisticsBar.vue?vue&type=script&lang=js"
export * from "./StatisticsBar.vue?vue&type=script&lang=js"

import "./StatisticsBar.vue?vue&type=style&index=0&id=61dd0618&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dd0618"]])

export default __exports__